<template>
  <div class="tab-bar">
    <div :style="banner">
      <div class="visit-info">
        <span @click="home">参观须知</span>
        <span @click="home">VISITING INSTRUCTIONS</span>
        <div class="order">
          <button @click="booking1">个人预约</button>
          <button @click="booking2">团队预约</button>
          <button @click="order">历史订单</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tabbar",
  data () {
    return {
      banner: {
        // backgroundImage: "url(" + require("@/assets/icons/banner.png") + ")",
        backgroundImage: "",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundImage:
          "linear-gradient(90deg,rgba(147, 57, 32, 0.8),rgba(211, 117, 71, 0.5))"
      },
      ispersonal: ""
    };
  },

  props: ['canOrder', 'teamRemark'],
  
  methods: {
    //个人预约
    booking1 () {
      this.ispersonal = true;
      this.$router.push({
        name: "bookingInfo",
        query: {
          id: this.ispersonal
        }
      });
      location.reload();
    },
    //团队预约
    booking2 () {
      if (this.canOrder) {
        this.ispersonal = false;
        this.$router.push({
          name: "bookingInfo",
          query: {
            id: this.ispersonal
          }
        });
        location.reload();
      } else {
        this.$notify.info({
          title: "温馨提示",
          message: this.teamRemark,
          customClass: "notification",
          duration: 4000,
        });
      }
    },
    //我的订单
    order () {
      this.$router.push({
        name: "myOrder"
      });
    },
    home () {
      this.$router.push({
        name: "home"
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/tabBar/tabBar.vue